import { Box, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import EventCard from "./EventCard";
import { getAllEvents, } from "../../../../Redux/Reducers/communityReducer";
import Noevent from "../../../../Assets/css/Community/NoEvents.webp";
import { useLocation } from "react-router-dom";

// Main Component - Maps events
const EventScreen = () => {
  const dispatch = useDispatch();
  const events = useSelector((state) => state?.community?.events);
  const exploreType = useSelector((state) => state?.community?.exploreType);
  const location = useLocation();
  const scrollToEventId = location.state?.scrollToEventId;
  const EventRefs = useRef({});

  useEffect(() => {
    if (scrollToEventId && EventRefs.current[scrollToEventId]) {
      EventRefs.current[scrollToEventId].scrollIntoView({ block: "center"}); // or add behavior: "auto"
    }
  }, [events]);


  useEffect(() => {
    const params={ page: 0, my_events: false, type:exploreType }
    dispatch(getAllEvents(params));
  }, [dispatch]);



  if (!events || events?.length === 0) {
    return (<div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "60vh",
              textAlign: "center",
              color: "#555",
              
            }}
          >
        <img
              src={Noevent} 
              alt="No Events"
              style={{ width: "80px", marginBottom: "16px", opacity: 0.8 }}
            />
        <Typography variant="h6">No events found</Typography>
        </div>);
  }

  return (
// Add ID to events container
<Box id="events-container" >
  {events?.map((event) => (
    <EventCard key={event?.id} event={event} ref={(el) => (EventRefs.current[event?.id] = el)} />
  ))}
</Box>
  );
};

export default EventScreen;
